import { PintoEbookSubmissionItemStatus, PintoEbookSubmissionStatus } from '../../../core/graphql/types';

export const EBOOK_SUBMISSION_STATUS_CLASS_NAME: Record<PintoEbookSubmissionStatus, string> = {
  [PintoEbookSubmissionStatus.Pending]: 'badge',
  [PintoEbookSubmissionStatus.Processing]: 'badge badge-warning',
  [PintoEbookSubmissionStatus.Completed]: 'badge badge-success',
  [PintoEbookSubmissionStatus.Cancelled]: 'badge badge-error',
};

export const EBOOK_SUBMISSION_STATUS_LABEL: Record<PintoEbookSubmissionStatus, string> = {
  [PintoEbookSubmissionStatus.Pending]: 'Pending',
  [PintoEbookSubmissionStatus.Processing]: 'Processing',
  [PintoEbookSubmissionStatus.Completed]: 'Completed',
  [PintoEbookSubmissionStatus.Cancelled]: 'Cancelled',
};

export const EBOOK_SUBMISSION_ITEM_STATUS_CLASS_NAME: Record<PintoEbookSubmissionItemStatus, string> = {
  [PintoEbookSubmissionItemStatus.Pending]: 'badge',
  [PintoEbookSubmissionItemStatus.Processing]: 'badge badge-warning',
  [PintoEbookSubmissionItemStatus.Completed]: 'badge badge-success',
  [PintoEbookSubmissionItemStatus.Cancelled]: 'badge badge-error',
  [PintoEbookSubmissionItemStatus.Failed]: 'badge badge-error',
};

export const EBOOK_SUBMISSION_ITEM_STATUS_LABEL: Record<PintoEbookSubmissionItemStatus, string> = {
  [PintoEbookSubmissionItemStatus.Pending]: 'Pending',
  [PintoEbookSubmissionItemStatus.Processing]: 'Processing',
  [PintoEbookSubmissionItemStatus.Completed]: 'Completed',
  [PintoEbookSubmissionItemStatus.Cancelled]: 'Cancelled',
  [PintoEbookSubmissionItemStatus.Failed]: 'Failed',
};
